export default {
  SET_MINIVARIANT(state, value) {
    state.minivariant = value;
  },
  TOGGLE_MINIVARIANT(state) {
    state.minivariant = !state.minivariant;
  },
};
